/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationEmail } from './NotificationEmail';
import {
    NotificationEmailFromJSON,
    NotificationEmailFromJSONTyped,
    NotificationEmailToJSON,
    NotificationEmailToJSONTyped,
} from './NotificationEmail';

/**
 * Settings for all settings. This is a "singleton": there's only a single row on each instance. The backend does not create or delete rows, it only updates this one row.
 * @export
 * @interface Setting
 */
export interface Setting {
    /**
     * 
     * @type {string}
     * @memberof Setting
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof Setting
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Setting
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof Setting
     */
    preOpsMessage: string;
    /**
     * 
     * @type {number}
     * @memberof Setting
     */
    preOpsHoursUntilRecheck?: number | null;
    /**
     * 
     * @type {Array<NotificationEmail>}
     * @memberof Setting
     */
    preOpsNotificationEmails: Array<NotificationEmail>;
    /**
     * 
     * @type {boolean}
     * @memberof Setting
     */
    preOpsRecheckOnDriverChange: boolean;
    /**
     * 
     * @type {string}
     * @memberof Setting
     */
    impactMessage: string;
    /**
     * 
     * @type {Array<NotificationEmail>}
     * @memberof Setting
     */
    impactNotificationEmails: Array<NotificationEmail>;
    /**
     * 
     * @type {Array<NotificationEmail>}
     * @memberof Setting
     */
    maintenanceNotificationEmails: Array<NotificationEmail>;
    /**
     * 
     * @type {boolean}
     * @memberof Setting
     */
    generateDemoData: boolean;
    /**
     * 
     * @type {string}
     * @memberof Setting
     */
    openidConnectClientId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Setting
     */
    openidConnectClientSecret?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Setting
     */
    openidConnectIssuerUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Setting
     */
    universalPin?: string | null;
}

/**
 * Check if a given object implements the Setting interface.
 */
export function instanceOfSetting(value: object): value is Setting {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('preOpsMessage' in value) || value['preOpsMessage'] === undefined) return false;
    if (!('preOpsNotificationEmails' in value) || value['preOpsNotificationEmails'] === undefined) return false;
    if (!('preOpsRecheckOnDriverChange' in value) || value['preOpsRecheckOnDriverChange'] === undefined) return false;
    if (!('impactMessage' in value) || value['impactMessage'] === undefined) return false;
    if (!('impactNotificationEmails' in value) || value['impactNotificationEmails'] === undefined) return false;
    if (!('maintenanceNotificationEmails' in value) || value['maintenanceNotificationEmails'] === undefined) return false;
    if (!('generateDemoData' in value) || value['generateDemoData'] === undefined) return false;
    return true;
}

export function SettingFromJSON(json: any): Setting {
    return SettingFromJSONTyped(json, false);
}

export function SettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): Setting {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'preOpsMessage': json['preOpsMessage'],
        'preOpsHoursUntilRecheck': json['preOpsHoursUntilRecheck'] == null ? undefined : json['preOpsHoursUntilRecheck'],
        'preOpsNotificationEmails': ((json['preOpsNotificationEmails'] as Array<any>).map(NotificationEmailFromJSON)),
        'preOpsRecheckOnDriverChange': json['preOpsRecheckOnDriverChange'],
        'impactMessage': json['impactMessage'],
        'impactNotificationEmails': ((json['impactNotificationEmails'] as Array<any>).map(NotificationEmailFromJSON)),
        'maintenanceNotificationEmails': ((json['maintenanceNotificationEmails'] as Array<any>).map(NotificationEmailFromJSON)),
        'generateDemoData': json['generateDemoData'],
        'openidConnectClientId': json['openidConnectClientId'] == null ? undefined : json['openidConnectClientId'],
        'openidConnectClientSecret': json['openidConnectClientSecret'] == null ? undefined : json['openidConnectClientSecret'],
        'openidConnectIssuerUrl': json['openidConnectIssuerUrl'] == null ? undefined : json['openidConnectIssuerUrl'],
        'universalPin': json['universalPin'] == null ? undefined : json['universalPin'],
    };
}

export function SettingToJSON(json: any): Setting {
    return SettingToJSONTyped(json, false);
}

export function SettingToJSONTyped(value?: Setting | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'preOpsMessage': value['preOpsMessage'],
        'preOpsHoursUntilRecheck': value['preOpsHoursUntilRecheck'],
        'preOpsNotificationEmails': ((value['preOpsNotificationEmails'] as Array<any>).map(NotificationEmailToJSON)),
        'preOpsRecheckOnDriverChange': value['preOpsRecheckOnDriverChange'],
        'impactMessage': value['impactMessage'],
        'impactNotificationEmails': ((value['impactNotificationEmails'] as Array<any>).map(NotificationEmailToJSON)),
        'maintenanceNotificationEmails': ((value['maintenanceNotificationEmails'] as Array<any>).map(NotificationEmailToJSON)),
        'generateDemoData': value['generateDemoData'],
        'openidConnectClientId': value['openidConnectClientId'],
        'openidConnectClientSecret': value['openidConnectClientSecret'],
        'openidConnectIssuerUrl': value['openidConnectIssuerUrl'],
        'universalPin': value['universalPin'],
    };
}

